export default {"src":"/_next/static/media/fish.0d8a619a.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};